<script context="module"></script>

<script>export let styles;
export let id;
export let nonce;
</script>

{@html `<${"style"}  data-id=${id}  nonce=${nonce}  >${styles}<${"/style"}>`}